import { render } from "./InstagramFollowers.vue?vue&type=template&id=e0c1553a&scoped=true&ts=true"
import script from "./InstagramFollowers.vue?vue&type=script&lang=ts"
export * from "./InstagramFollowers.vue?vue&type=script&lang=ts"

import "./InstagramFollowers.vue?vue&type=style&index=0&id=e0c1553a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c1553a"]])

export default __exports__